import {FaMapMarkerAlt} from "react-icons/fa";
import {useSelector} from "react-redux";
import {contactMethodsLinks} from "@utils/types/contactMethodsTypes";
import SetInnerHtml from "@components/setInnerHtml";

import "./style.scss";

const ContactBar = () => {
    const address = useSelector(state => state.UI.general?.address);
    const contactMethods = useSelector(state => state.UI.general?.social_media);

    const primaryContactMethods = contactMethods?.filter(contactMethod => parseInt(contactMethod.is_primary));

    return (
        <div className="contact-bar d-flex justify-content-between">
            <div className="d-none d-md-block">
                <FaMapMarkerAlt/>
                <span>{address?.text}</span>
            </div>
            <div className="d-flex mx-auto mx-md-0">
                {primaryContactMethods?.map((item) =>
                    <a
                        aria-label={'.'}
                        key={item.id}
                        href={contactMethodsLinks(item.type, item.value)}
                        rel="noreferrer"
                        target="_blank"
                        title={`${item.title}: ${item.value}`}
                    >
                        <SetInnerHtml html={item.icon} className="contact-bar-icon d-flex"/>

                    </a>
                )}
            </div>
        </div>
    )
}

export default ContactBar;